import { call } from "./api";
import { getCredentials } from "./session"
import config from "../config/app";
import AWS from 'aws-sdk';
import { v4 as uuidv4 } from 'uuid';
import path from 'path';

export const count = params => {
    return call(client => {
        return client.get(`/movies/count`, params);
    });
};

export const search = params => {
    return call(client => {
        return client.get(`/movies`, params);
    });
};

export const add = params => {
    const fileName = uuidv4() + path.extname(params.path);

    const postMovie = client => {
        return client.post(`/movies`, {
            path: fileName,
            name: params.name,
            mode: params.mode,
            transcodeModeId: params.transcodeModeId,
            status: 'uploading',
            sub: params.sub,
            username: params.username,
        });
    };

    let id;
    return new Promise((resolve, reject) => {
        call(postMovie)
        .then(response => {
            id = response.data.id;
            return getCredentials()
        })
        .then(credentials => {
            const s3 = new AWS.S3({
                region: config.aws.region,
                credentials: credentials,
            });

            const s3Options = {
                partSize: 50 * 1024 * 1024,
                queueSize: 5
            };

            return s3.upload({
                Bucket: config.aws.s3.bucket,
                Body: params.body,
                Key: `movies/original/${fileName}`
            }, s3Options).promise();
        })
        .then(() => {
            resolve();
        })
        .catch(err => {
            call(client => {
                client.put(`/movies/${id}`, {
                    id: id,
                    path: fileName,
                    name: params.name,
                    mode: params.mode,
                    duration: null,
                  　transcodeModeId: params.transcodeModeId,
                    status: 'uploadError'
                });
            });
            reject(err);
        })
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/movies/${id}`, params);
    });
};

export const remove = (id, path, status) => {
    return new Promise((resolve, reject) => {
        call(client => {
            return client.delete(`/movies/${id}`, {});
        })
        .then(() => {
            return getCredentials();
        })
        .then(credentials => {
            const s3 = new AWS.S3({
                region: config.aws.region,
                credentials: credentials,
            });

            const params = {
                Bucket: config.aws.s3.bucket,
                Key: `movies/original/${path}`
            };

            const promises = [
                s3.deleteObject(params).promise(),
            ];

            if (status === 'transcoded' ||
                status === 'drmConverting' ||
                status === 'drmConvertError' ||
                status === 'completed'
            ) {
                promises.push(deleteTranscodedObjects(path, s3, 'transcoded'));
            }

            // DRM動画 削除
            if (status === 'completed') {
                promises.push(deleteTranscodedObjects(path, s3, 'drm'));
            }

            return Promise.all(promises);
        })
        .then(() => {
            resolve();
        })
        .catch(err => {
            reject(err);
        })
    });
};

/**  S3のmovies/transcoded/配下にあるフォルダと、そのフォルダ内のオブジェクトを全て削除する関数式　*/
const deleteTranscodedObjects = (path, s3, prefix) => {
    return new Promise((resolve, reject) => {
        const params = {
            Bucket: config.aws.s3.bucket,
            Prefix: `movies/${prefix}/${path}`
        };

        s3.listObjectsV2(params).promise()
        .then(res => {
            const deleteObjects = [{ Key: params.Prefix }];

            for (let i = 0; i < res.Contents.length; i++) {
                deleteObjects.push({ Key: res.Contents[i].Key });
            }

            const deleteParams = {
                Bucket: params.Bucket,
                Delete: {
                    Objects: deleteObjects
                }
            };

            return s3.deleteObjects(deleteParams).promise();
        })
        .then(() => {
            resolve();
        })
        .catch(err => {
            reject(err);
        })
    });
};

export const getIssueSignedUrl = (movieId) => {
    return call(client => {
        return client.get(`/users/movies/${movieId}/manifest`);
    });
};

export const batchRemove = selectedItemInfo => {
  return Promise.all(selectedItemInfo.map(item => {
      return remove(item.id, item.path, item.status);
  }))
};


// WEBPACK FOOTER //
// ./src/api/movie.js